export enum ViewLoadState {
  FETCHING,
  FETCHED,
  ERROR,
  NO_DATA
}
